import React, { useState } from 'react';
import { Gauge, Zap, Sparkles } from 'lucide-react';
import HiringPressure from './HiringPressure';
import HiringSurge from './HiringSurge';
import FutureHiring from './FutureHiring';

const MODES = [
  { key: 'pressure', label: 'Hiring Pressure', icon: Gauge, Component: HiringPressure },
  { key: 'surge', label: 'Surge Detector', icon: Zap, Component: HiringSurge },
  { key: 'future', label: 'Future Hiring', icon: Sparkles, Component: FutureHiring },
];

export default function GrowthMomentumView({ embedded = false, initialMode = 'pressure' }) {
  const [mode, setMode] = useState(MODES.some(m => m.key === initialMode) ? initialMode : 'pressure');
  const ActiveMode = MODES.find(m => m.key === mode)?.Component || HiringPressure;

  return (
    <div>
      <div className="flex items-center gap-2 bg-white border-b border-gray-200 px-6 py-3" data-testid="growth-momentum-mode-toggle">
        {MODES.map(m => (
          <button
            key={m.key}
            onClick={() => setMode(m.key)}
            data-testid={`growth-momentum-mode-${m.key}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border transition-colors ${
              mode === m.key ? 'bg-[#0A1F44] text-white border-[#0A1F44]' : 'bg-white text-gray-500 border-gray-200 hover:border-[#0A1F44]/40'
            }`}
          >
            <m.icon className="h-3 w-3" /> {m.label}
          </button>
        ))}
      </div>
      <ActiveMode embedded={embedded} />
    </div>
  );
}
